import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';
import IntegrationsGridController from '../controller/IntegrationsGridController';

export default class IntegrationsGridComponent extends BaseWebComponentElement {
  constructor() {
    super();

    this.initialSetup({
      controllerConstructor: IntegrationsGridController,
    });
  }
}
